module.exports = __webpack_public_path__ + "static/kinaxis-17ca506c1aabb3a5376f8ff45ec7cc8c.png";